import React, { useEffect, useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from '@mui/material';
import backendService from '../../services/BackendService';
import { useTranslation } from 'react-i18next';
import { SessionCheckDialogStyle } from './styles';

interface SessionCheckDialogProps {
  sessionId: string;
  treatmentId: string;
}

const SessionCheckDialog: React.FC<SessionCheckDialogProps> = ({ sessionId, treatmentId }) => {
  const [isSessionOld, setIsSessionOld] = useState<boolean>(false);
  const { t } = useTranslation();
  const { sessionCheckDialogContainer } = SessionCheckDialogStyle;

  useEffect(() => {
    const isOld = async () => {
      try {
        const result = await backendService.getHasNewSession(sessionId, treatmentId);
        return result;
      } catch (error) {
        console.error(`Unable to get session data: ${error}`);
        return false;
      }
    };

    const checkIfOld = async () => {
      const isSessionOld = await isOld();
      setIsSessionOld(isSessionOld);
    };

    checkIfOld();

    // Set interval to run every hour (3600000 milliseconds)
    const intervalId = setInterval(checkIfOld, 3600000);

    // Cleanup interval on unmount
    return () => clearInterval(intervalId);
  }, [sessionId, treatmentId]);

  return (
    <Dialog
      open={isSessionOld}
      onClose={() => setIsSessionOld(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={sessionCheckDialogContainer}
      data-testid="pwid-session-check-dialog"
    >
      <DialogTitle className={'title-content'} id="alert-dialog-title">
        {t('session-duration-title')}
      </DialogTitle>
      <DialogContent className="main-container">
        <DialogContentText className="container-text" id="alert-dialog-description">
          {t('session-duration-text')}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button className="button-settings" onClick={() => setIsSessionOld(false)} data-testid="pwid-session-check-ok">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SessionCheckDialog;
